module.exports = __webpack_public_path__ + "media/assets/images/flags/xk-a01c5b3af668f4b82ad4288546e1c938.svg";